<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<div class="context-text-row font-body2 font-color-tertiary">
    @if (data.context.matIcon) {
        <mat-icon class="context-icon" [svgIcon]="data.context.matIcon"></mat-icon>
    }
    <div
        [innerHtml]="
            data.context.translated ? data.context.text : (data.context.text | translate: data.context.placeholders)
        "
    ></div>
</div>
